import axios from 'axios'
import qs from 'qs'
import { getToken } from '@/libs/cookie-storage'

const ACCESS_KEY = 'baseball-stats'

function buildStatsUrl(path, params = {}) {
  const base = process.env.VUE_APP_STATS_API || ''
  const passport = getToken()
  const q = { ...params, accessKey: ACCESS_KEY }
  if (passport) {
    q.passport = passport
  }
  const query = qs.stringify(q)
  return `${base}${path}${query ? `?${query}` : ''}`
}

/**
 * 棒球球员榜：维度列表（投球/进攻各指标）
 * GET /api/res/rankings/player
 */
export function fetchBaseballRankingsMeta(accountId) {
  const url = buildStatsUrl('/api/res/rankings/player', {
    accountId: String(accountId),
  })
  return axios.get(url).then(res => {
    const body = res.data || {}
    const messages = body.messages || {}
    const data = messages.data
    const ok = body.code === 200 && body.ok !== false
    return { ok, data, raw: body }
  })
}

/**
 * 棒球球员榜：某一指标排行数据
 * GET /api/rpes/rankings/player/:prop
 */
export function fetchBaseballPlayerRanking({ accountId, prop, stageId, pageSize = 500 }) {
  const safeProp = encodeURIComponent(String(prop || '').replace(/^\//, ''))
  const url = buildStatsUrl(`/api/rpes/rankings/player/${safeProp}`, {
    accountId: String(accountId),
    stageId: String(stageId),
    pageSize,
  })
  return axios.get(url).then(res => {
    const body = res.data || {}
    const messages = body.messages || {}
    const data = messages.data
    const ok = body.code === 200 && body.ok !== false
    return { ok, data, raw: body }
  })
}
